import { HttpContextToken, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

export const ExcludeCsrfToken = new HttpContextToken<boolean>(() => false);
export const BoldRequest = new HttpContextToken<boolean>(() => false);

export abstract class CsrfTokenService implements HttpInterceptor {
  protected static readonly _csrfHeaderName = 'X-CSRF-TOKEN';

  abstract readonly needsCsrfTokenRequest: boolean;

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(this._setHeaderIfNeeded(request));
  }

  abstract set(token: string): void;

  protected abstract _readTokenValue(): string;

  protected _setHeaderIfNeeded(request: HttpRequest<any>): HttpRequest<any> {
    const tokenValue = this._readTokenValue();
    const skipCsrf = !request.context || request.context.get(ExcludeCsrfToken) || !request.context.get(BoldRequest);

    return tokenValue && !skipCsrf
      ? request.clone({ setHeaders: { [CsrfTokenService._csrfHeaderName]: tokenValue } })
      : request;
  }
}
